import { Injectable } from '@angular/core';
import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';
import { NotificationService } from '@app/core/services/notification/notification.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  parentRouteParam!: any;
  userRole!: any;
  private last403At = 0;
  constructor( private notification: NotificationService, private router: Router, private activatedRoute: ActivatedRoute ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isValidRequestForInterceptor(request.url)) {
      const token = localStorage.getItem('userToken');

      if (token) {
        request = request.clone({
          headers: request.headers.set(
            'Authorization',
            'Bearer ' + localStorage.getItem('userToken')
          )
        });
      }

      if (!request.headers.has('Content-Type')) {
        request = request.clone({
          headers: request.headers.set('Content-Type', 'application/json')
        });
      }
      if (request.body instanceof FormData) {
        request = request.clone({ headers: request.headers.delete('Content-Type') });
      }

      request = request.clone({
        headers: request.headers.set('Accept', 'application/json')
      });
    }

    const resetUrlToRedirect = window.location.pathname + window.location.search;
    this.userRole = localStorage.getItem('role');
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.status === 401 || event.status === 403) {
              this.notification.error('Please login again', 'Session expired');
              if (this.userRole === 'SuperAdmin' || this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
                localStorage.clear();
                this.router.navigate(['/']);
              } else {
                const sch = JSON.parse(localStorage.getItem('colorScheme'));
                const storeUrl = localStorage.getItem('storeUrl');
                // As once user logout and re-login, we send store id at backend API. So fetching and again setting in local storage.
                const savestoreId = localStorage.getItem('storeId');
                localStorage.clear();
                localStorage.setItem('storeId', savestoreId);
                localStorage.setItem('colorScheme', JSON.stringify(sch));
                this.router.navigate(['/', storeUrl]);
              }

              window.localStorage.setItem('urlToRedirect', resetUrlToRedirect);
            }
          }},
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            // Handling order detail error response, as route resolver is not working in case of token expiration.
            if ((error.status === 401 || error.status === 403) && error.url.indexOf('/Order/GetOrderDetail') !== -1) {
              this.notification.error('Please login again', 'Session expired');
              if (this.userRole === 'SuperAdmin' || this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
                localStorage.clear();
                this.router.navigate(['/']);
              } else {
                const sch = JSON.parse(localStorage.getItem('colorScheme'));
                const storeUrl = localStorage.getItem('storeUrl');
                // As once user logout and re-login, we send store id at backend API. So fetching and again setting in local storage.
                const savestoreId = localStorage.getItem('storeId');
                localStorage.clear();
                localStorage.setItem('storeId', savestoreId);
                localStorage.setItem('colorScheme', JSON.stringify(sch));
                this.router.navigate(['/', storeUrl]);
              }

              window.localStorage.setItem('urlToRedirect', resetUrlToRedirect);
            } else if (error.status === 403) {
              // Generic permission-denied toast for every other 403 across the app.
              // Debounced so a page firing several parallel requests doesn't stack duplicate toasts.
              const now = Date.now();
              if (now - this.last403At > 2000) {
                this.last403At = now;
                this.notification.error('You do not have enough permission to perform this action', 'Access Denied');
              }
            }
          }
        }
      ));
  }

  private isValidRequestForInterceptor(requestUrl: string): boolean {
    let positionIndicator: string = 'stores.inksoft.com';
    let position = requestUrl.indexOf(positionIndicator);
    if (position > 0) {
      return false;
    }
    return true;
  }
}
